import { remove } from '../index';

export const removeObject = obj => {
  return remove('/projects', obj);
};
